import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../Context/GlobalContext";
import storage from "../Assets/js/Global";
import { Alert } from "react-bootstrap";
import { images } from "../Assets/images";
import HeightModal from "../modals/HeightModal";
import WeightModal from "../modals/WeightModal";

const StartScan = () => {
  const {
    translatedLabels,
    editUserDetails,
    userDetails,
    getUserDetails,
    setMsgLoader,
    getUserScanLimit,
    scanLimit,
    is4Life,
  } = useContext(GlobalContext);
  const authLabel = translatedLabels?.auth;
  const screenLabels = translatedLabels?.common;
  const [showWeightModal, setWeightModal] = useState(false);
  const [showHeightModal, setShowHeightModal] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    storage.set("scanGuest", false);
    getUserDetails();
    getUserScanLimit();
  }, [getUserDetails]);

  const [profileData, setProfileData] = useState({
    gender: "",
    dob: "",
    age: "",
    weight: "",
    weightUnit: "kg",
    height: "",
    heightUnit: "cm",
    smoking: "",
    race: "",
    diabetes: "",
    cameraMode: "front",
  });

  useEffect(() => {
    if (userDetails) {
      // let formattedDob = "";

      const diabetes = userDetails.diabetes || "";
      setProfileData({
        gender: userDetails.gender || "",
        // dob: formattedDob,
        age: userDetails.age || "",
        weight: userDetails.weight || "",
        weightUnit: userDetails.weight_unit || "kg",
        height: userDetails.height || "",
        heightUnit: userDetails.height_unit || "cm",
        smoking: userDetails.smoking || "",
        race: userDetails.race || "",
        diabetes,
        cameraMode: userDetails.cameraMode || "front",
      });
    }
  }, [userDetails]);

  const handleStartScan = () => {
    setFormSubmitted(true);
    setMsgLoader(true);
    const finalData = {
      ...profileData,
      // dob: formattedDob,
    };

    editUserDetails(finalData);
  };

  const SKIN_TONES = [
    {
      key: "Very Light",
      v: screenLabels?.skin_tone_very_light?.label_value || "Very Light",
      c: "#F5D5C0",
    },
    {
      key: "Light",
      v: screenLabels?.skin_tone_light?.label_value || "Light",
      c: "#E8B89A",
    },
    {
      key: "Light Medium",
      v: screenLabels?.skin_tone_light_medium?.label_value || "Light Medium",
      c: "#D69875",
    },
    {
      key: "Medium",
      v: screenLabels?.skin_tone_medium?.label_value || "Medium",
      c: "#B97B57",
    },
    {
      key: "Medium Dark",
      v: screenLabels?.skin_tone_medium_dark?.label_value || "Medium Dark",
      c: "#8E5A3D",
    },
    {
      key: "Dark",
      v: screenLabels?.skin_tone_dark?.label_value || "Dark",
      c: "#5F3825",
    },
    {
      key: "Very Dark",
      v: screenLabels?.skin_tone_very_dark?.label_value || "Very Dark",
      c: "#3E2417",
    },
  ];

  return (
    <div className="content-part mb-4">
      <div className="form-group">
        <label className="form-label question-label">
          {authLabel?.what_is_your_gender?.label_value ||
            "What is your gender?"}
        </label>
        <div className="d-flex w-100 gap-3">
          {/* Male */}
          <div
            className={`custom-checkbox custom-selection position-relative w-50 ${profileData.gender === "male" ? "active-selection" : ""}${formSubmitted && !profileData.gender ? " border border-danger" : ""}`}
            onClick={() => setProfileData((p) => ({ ...p, gender: "male" }))}
          >
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <div className="input-image">
                  <img src={images.maleImg} alt="male" />
                </div>
                <p className="mb-0 fw-semibold">
                  {authLabel?.male?.label_value || "Male"}
                </p>
              </div>
              <input
                type="radio"
                id="startScanMaleOption"
                name="startScanGender"
                value="male"
                checked={profileData.gender === "male"}
                onChange={() =>
                  setProfileData((p) => ({ ...p, gender: "male" }))
                }
                hidden
              />
              <label
                htmlFor="startScanMaleOption"
                className="custom-label-left"
              ></label>
            </div>
          </div>

          {/* Female */}
          <div
            className={`custom-checkbox custom-selection position-relative w-50 ${profileData.gender === "female" ? "active-selection" : ""}${formSubmitted && !profileData.gender ? " border border-danger" : ""}`}
            onClick={() => setProfileData((p) => ({ ...p, gender: "female" }))}
          >
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <div className="input-image">
                  <img src={images.femaleImg} alt="female" />
                </div>
                <p className="mb-0 fw-semibold">
                  {authLabel?.female?.label_value || "Female"}
                </p>
              </div>
              <input
                type="radio"
                id="startScanFemaleOption"
                name="startScanGender"
                value="female"
                checked={profileData.gender === "female"}
                onChange={() =>
                  setProfileData((p) => ({ ...p, gender: "female" }))
                }
                hidden
              />
              <label
                htmlFor="startScanFemaleOption"
                className="custom-label-left"
              ></label>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div className="form-group mt-3">
          <label className="form-label question-label">
            {authLabel?.what_is_your_age?.label_value || "What is your age?"}
          </label>
          <input
            type="number"
            placeholder={
              screenLabels?.enter_your_age?.label_value ||
              "Enter your age"
            }
            className={`form-control wrInputText ${formSubmitted && !profileData?.age?.toString().trim() ? "is-invalid" : ""}`}
            value={profileData?.age || ""}
            onChange={(e) =>
              setProfileData((prev) => ({
                ...prev,
                age: e.target.value,
              }))
            }
          />
        </div>
      </div>

      <div className="form-group mt-3">
        <label className="form-label question-label mb-0">
          {authLabel?.what_is_your_weight?.label_value ||
            "What is your weight?"}{" "}
        </label>

        <input
          type="text"
          className={`form-control wrInputText ${formSubmitted && !profileData.weight ? "is-invalid" : ""}`}
          placeholder={authLabel?.enter_weight?.label_value || "Enter weight"}
          readOnly
          value={
            profileData.weight
              ? `${profileData.weight} ${profileData.weightUnit}`
              : ""
          }
          onClick={() => setWeightModal(true)}
        />
      </div>

      <div className="form-group mt-3 ">
        <label className="form-label question-label mb-0">
          {authLabel?.what_is_your_height?.label_value ||
            "What is your height?"}{" "}
        </label>

        <div className="input-group">
          <input
            type="text"
            className={`form-control wrInputText ${formSubmitted && !profileData.height ? "is-invalid" : ""}`}
            placeholder={authLabel?.enter_height?.label_value || "Enter height"}
            readOnly
            value={
              profileData.height
                ? `${profileData.height} ${profileData.heightUnit}`
                : ""
            }
            onClick={() => setShowHeightModal(true)}
          />
        </div>
      </div>

      <div className="form-group mt-3 mb-4">
        <label className="form-label question-label">
          {authLabel?.skin_text?.label_value || "What is your skin tone?"}
        </label>
        <div className="d-flex flex-wrap gap-2 mt-2">
          {SKIN_TONES.map((tone) => (
            <div
              key={tone.key}
              onClick={() => setProfileData((p) => ({ ...p, race: tone.key }))}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                cursor: "pointer",
                padding: "8px",
                borderRadius: "8px",
                border:
                  profileData?.race === tone.key
                    ? "3px solid #007bff"
                    : "2px solid #ddd",
                transition: "all 0.2s",
              }}
              title={tone.v}
            >
              <div
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                  backgroundColor: tone.c,
                  border: "1px solid rgba(0, 0, 0, 0.12)",
                  boxShadow: "rgba(0, 0, 0, 0.18) 0px 1px 2px inset",
                  marginBottom: "4px",
                }}
              />
              <small
                style={{ fontSize: "11px", textAlign: "center", width: "60px" }}
              >
                {tone.v}
              </small>
            </div>
          ))}
        </div>
      </div>

      <div className="mb-3">
        <h6>{screenLabels?.disclaimer?.label_value || "Disclaimer"}</h6>
        <p className="fs-15px">
          {is4Life
            ? screenLabels?.fourLife_disclaimer_content?.label_value
            : screenLabels?.disclaimer_content?.label_value ||
            "The metrics provided by GlobalHealth AI are wellness estimates and are intended for informational and general health awareness purposes only. This app is not a medical device and does not diagnose, monitor, or treat medical conditions. Please consult a qualified healthcare professional for medical advice."}
        </p>
      </div>
      <div className="pb-4">
        <h6>
          {screenLabels?.scan_guidelines?.label_value || "Scan Guidelines"}
        </h6>
        <ul className="m-0 ps-3">
          <li className="mb-2 fs-15px">
            {screenLabels?.scan_guideline1?.label_value ||
              "Keep your face evenly illuminated."}
          </li>
          <li className="mb-2 fs-15px">
            {screenLabels?.scan_guideline2?.label_value ||
              "Use a single light source directed at your face."}
          </li>
          <li className="mb-2 fs-15px">
            {screenLabels?.scan_guideline3?.label_value ||
              "Sit where no light falls directly on the camera."}
          </li>
          <li className="mb-2 fs-15px">
            {screenLabels?.scan_guideline4?.label_value ||
              "Ensure the camera area isn’t exposed to sunlight."}
          </li>
          <li className="mb-2 fs-15px">
            {screenLabels?.scan_guideline5?.label_value ||
              "Avoid movement of people in the background."}
          </li>
          <li className="mb-2 fs-15px">
            {screenLabels?.scan_guideline6?.label_value ||
              "Remove reflective items like mirrors, glass, or shiny tables."}
          </li>
        </ul>
      </div>

      {scanLimit === true ? (
        <div className="text-center start-scan-button">
          <button className="btn btn-primary" onClick={handleStartScan}>
            {screenLabels?.start_scan?.label_value || "Start Scan"}
          </button>
        </div>
      ) : (
        <>
          <div className="text-center start-scan-button w-100 p-3">
            <Alert variant="danger" className="p-1 m-0 bg-danger">
              <p className="m-0 text-white">
                You’ve hit your monthly scan limit.
              </p>
            </Alert>
          </div>
        </>
      )}
      <WeightModal
        show={showWeightModal}
        onClose={() => setWeightModal(false)}
        initialWeight={profileData.weight}
        initialUnit={profileData.weightUnit}
        onSave={({ weight, weightUnit }) => {
          if (weightUnit === "kg") {
            if (weight < 20 || weight > 300) {
              window.showToast("error", "Weight must be between 20–300 kg.");
              return;
            }
          } else if (weightUnit === "lbs") {
            if (weight < 44 || weight > 661) {
              window.showToast("error", "Weight must be between 44–661 lbs.");
              return;
            }
          }
          setProfileData((prev) => ({
            ...prev,
            weight,
            weightUnit,
          }));
          setWeightModal(false);
        }}
      />

      <HeightModal
        show={showHeightModal}
        onClose={() => setShowHeightModal(false)}
        initialHeight={profileData.height}
        initialUnit={profileData.heightUnit}
        onSave={({ height, heightUnit }) => {
          if (heightUnit === "cm") {
            if (height < 100 || height > 250) {
              window.showToast("error", "Height must be between 100–250 cm.");
              return;
            }
          } else if (heightUnit === "feet") {
            if (height < 3.3 || height > 8.2) {
              window.showToast("error", "Height must be between 3.3–8.2 feet.");
              return;
            }
          }
          setProfileData((prev) => ({
            ...prev,
            height,
            heightUnit,
          }));
          setShowHeightModal(false);
        }}
      />
    </div>
  );
};

export default StartScan;
